module.exports = __webpack_public_path__ + "static/media/wizualizacja-14.69ccf2c7.png";